import { Alert, AlertDescription, AlertTitle } from "@chakra-ui/react";
import { AlertIcon } from "view-layer/components/common/icons/AlertIcon";

export const CardDeclined = ({ single }: {single: boolean}) => (
  <Alert status="error" variant="error" data-testid="payment-declined-message">
    <AlertIcon status="error" />
    <AlertTitle>Payment not accepted</AlertTitle>
    {single
      ? <AlertDescription>Please try to make the payment with a different card.</AlertDescription>
      : <AlertDescription>Please try another payment method.</AlertDescription>
    }
  </Alert>
);